import React from 'react';
import PropTypes from 'prop-types';
import humanFormat from 'human-format';
import { subscribe, disconnect } from '../../../channels/pub-sub-service';

export default function ViewCount({ wire }) {
  const [count, setCount] = React.useState(wire.viewCount);

  React.useEffect(() => () => disconnect(), []);

  React.useEffect(() => {
    subscribe(
      { channel: 'WireStatisticChannel', id: wire.id },
      {
        received: data => {
          const { viewCount } = data;

          if (Number.isInteger(viewCount)) {
            setCount(viewCount);
          }
        },
      },
    );
  }, [wire.id]);

  return (
    <>
      <span className="icon-lw icon-lw-views" />
      <span className="count">{humanFormat(count, { decimals: 1 })}</span>
    </>
  );
}

ViewCount.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    viewCount: PropTypes.number.isRequired,
  }).isRequired,
};
